// src/components/Hero.js
import React from "react";
import "./Hero.css";
import { Col, Container, Row } from "react-bootstrap";
import Banner from "../../assets/Banner.png";
import {
  Facebook,
  Github,
  Linkedin,
  Envelope,
  Instagram,
} from "react-bootstrap-icons";

const Hero = () => {
  return (
    <Container fluid="md">
      <Row>
        <Col className="order-md-2 hero-img">
          <img src={Banner} alt="banner" />
        </Col>
        <Col className="order-md-1 hero-content">
          <h3>
            <span className="thin-font">Hello I'm </span>
            <span className="text-bold">Sandun De Silva.</span> <br />
            <span className="text-bold">Fullstack</span>{" "}
            <span className="text-border"> Developer</span>
          </h3>
          <p>
            An enthusiastic and dedicated software engineer with over{" "}
            <span style={{ color: "#000", fontWeight: "bold" }}>2 years</span>{" "}
            of hands-on experience in software engineering, and a graduate with{" "}
            <span style={{ color: "#000", fontWeight: "bold" }}>
              First Class Honors.
            </span>{" "}
            Currently seeking a new, challenging role where I can apply my
            skills and contribute to the company's improvement. I consider
            myself a fast learner with a passion for acquiring new skills,
            committed to continuous self-improvement, and dedicated to driving
            the success of the team and organization.
          </p>
          <div className="hero-socials">
            <div className="social-links">
              <a
                href="https://github.com/sandunde"
                target="_blank"
                rel="noreferrer"
              >
                <Github className="black-social" />
              </a>
            </div>
            <div className="social-links-white">
              <a
                href="https://www.linkedin.com/in/sandun-de-silva-6253861b8/"
                target="_blank"
                rel="noreferrer"
              >
                <Linkedin className="white-social" />
              </a>
            </div>
            <div className="social-links-white">
              <a
                href="mailto:sandundimaria7@gmail.com"
                target="_blank"
                rel="noreferrer"
              >
                <Envelope className="white-social" />
              </a>
            </div>
            <div className="social-links-white">
              <a
                href="https://www.instagram.com/sha.ggy_sus/"
                target="_blank"
                rel="noreferrer"
              >
                <Instagram className="white-social" />
              </a>
            </div>
            <div className="social-links-white">
              <a
                href="https://www.facebook.com/ab.dimaria.39"
                target="_blank"
                rel="noreferrer"
              >
                <Facebook className="white-social" />
              </a>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Hero;
